import { RESET_REPEATER_KEYS } from './';

export default resetRepeaters => ({
  type: RESET_REPEATER_KEYS,
  payload: { resetRepeaters },
});
